import "./KeywordsManagement.css";
import React, {memo, useCallback} from "react";
import {DataLoadingStatus} from "../../../Utils/enums";
import {deleteDivision, renameDivision, createCategory} from "../../../Utils/queries";
import {DivisionFull} from "../../../Utils/response-types";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEdit, faTrash, faPlusCircle} from "@fortawesome/free-solid-svg-icons";
import CategoryDisplay from "./CategoryDisplay";

const DivisionDisplay = ({activeDivision, setDivisions, status, setStatus}: {activeDivision: DivisionFull, setDivisions: React.Dispatch<React.SetStateAction<DivisionFull[]>>, status: DataLoadingStatus, setStatus: React.Dispatch<React.SetStateAction<DataLoadingStatus>>}) => {
    const handleRenameDivision = useCallback(() => {
        // eslint-disable-next-line no-restricted-globals
        const new_div_name = prompt("Are you sure you want to rename a division?\nThis is unusual action.\nEnter the new division name:");
        if (new_div_name !== null && new_div_name.length > 0) {
            setStatus(DataLoadingStatus.Loading);
            let old_div_list: DivisionFull[] = [];
            setDivisions((prev) => {
              old_div_list = prev;
              return prev.map((div) =>
                div.division_id === activeDivision.division_id
                  ? { ...div, division_name: new_div_name }
                  : div
              )
            });
            renameDivision(activeDivision.division_id, new_div_name).then(resp => {
                if (resp.errorCode !== undefined || !resp.success){
                    alert(resp.message || `Error: ${resp.errorCode}`);
                    setDivisions(old_div_list);
                } else {
                    alert("Division renamed successfully!");
                }
            });
            setStatus(DataLoadingStatus.Loaded);
        }
    }, [activeDivision, setDivisions, setStatus]);

    const handleDeleteDivision = useCallback(() => {
        // eslint-disable-next-line no-restricted-globals
        const confirmed = confirm("Do you really want to delete this division and all its categories? This action cannot be undone!");
        if (confirmed) {
            setStatus(DataLoadingStatus.Loading);
            let old_div_list: DivisionFull[] = [];
            setDivisions(prev => {old_div_list = prev; return prev.filter(div => div.division_id !== activeDivision.division_id)});
            deleteDivision(activeDivision.division_id).then(resp => {
                if (resp.errorCode !== undefined || !resp.success){
                    alert(resp.message || `Error: ${resp.errorCode}`);
                    setDivisions(old_div_list);
                } else {
                    alert("Division deleted successfully!");
                }
                setStatus(DataLoadingStatus.Loaded);
            });
        }
    }, [activeDivision, setDivisions, setStatus]);

    const handleAddCategory = useCallback(() => {
        // eslint-disable-next-line no-restricted-globals
        const new_cat_name = prompt("Enter the new category CSI name:");
        if (new_cat_name !== null && new_cat_name.length > 0) {
            // eslint-disable-next-line no-restricted-globals
            const new_cat_number = prompt("Enter the new category CSI number:");
            if (new_cat_number !== null && new_cat_number.length > 0 && /\d\d\s\d\d\s\d\d/.test(new_cat_number)) {
                setStatus(DataLoadingStatus.Loading);
                let old_div_list: DivisionFull[] = [];
                setDivisions((prev) => {
                  old_div_list = prev;
                  return prev.map((div) =>
                    div.division_id === activeDivision.division_id
                      ? { ...div, categories: [...div.categories, {division_id: activeDivision.division_id, category_id: -1, CSI_number: new_cat_number, CSI_name: new_cat_name, indicator_groups: []}] }
                      : div
                  )
                });
                createCategory(activeDivision.division_id, new_cat_number, new_cat_name).then(resp => {
                    if (resp.errorCode !== undefined || !resp.success) {
                        setDivisions(old_div_list);
                        alert(resp.message || `Error: ${resp.errorCode}`);
                        setStatus(DataLoadingStatus.Loaded);
                    } else {
                        setStatus(DataLoadingStatus.NotLoaded);
                        alert("Category successfully created!");
                    }
                });
            }
        }
    }, [activeDivision, setDivisions, setStatus]);

    return (
        <div className="division-management-main">
            <h1 className="division-name-h1">
                {activeDivision.division_name}
                {activeDivision.division_id !== -1 && <>
                    <button className="history-action-button" aria-label="Rename Division" title="Rename Division"
                            onClick={handleRenameDivision}><FontAwesomeIcon icon={faEdit}/></button>
                    <button className="history-action-button" aria-label="Delete Division" title="Delete Division"
                            onClick={handleDeleteDivision}><FontAwesomeIcon icon={faTrash}/></button>
                    <button className="history-action-button" aria-label="Add Category" title="Add Category"
                            onClick={handleAddCategory}><FontAwesomeIcon icon={faPlusCircle}/></button>
                </>}
            </h1>
            {activeDivision.categories.map(c => <CategoryDisplay key={c.category_id} category={c}
                                                                       attributes_list={activeDivision.attributes}
                                                                       setDivisions={setDivisions}
                                                                       status={status}
                                                                       setStatus={setStatus}/>)}
        </div>
    );
};


export default memo(DivisionDisplay);